<template>
  <div class="historic-page">
    <v-row>
      <Search :filters="true">
        <Filters />
      </Search>
    </v-row>
    <v-row>
      <v-col cols="12" lg="3" md="3" sm="12" xs="12" class="stats-col">
        <v-row class="pt-4 pa-0">
          <Info />
        </v-row>
      </v-col>
      <v-col cols="12" lg="9" md="9" sm="12" xs="12" class="content-col">
        <v-row>
          <List />
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Search from '@/templates/global/Search'
import Filters from './templates/Filters'
import Info from './templates/Info'
import List from './templates/List'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  components: { Search, Filters, Info, List },
  mixins: [ appdata, utils ]
}
</script>
